import script from "./CollegesListSpecialityScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./CollegesListSpecialityScreen.vue?vue&type=script&setup=true&lang=js"

import "./CollegesListSpecialityScreen.vue?vue&type=style&index=0&id=ab145dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab145dc2"]])

export default __exports__